<template>
  <div class="d-flex flex-column flex-column-fluid mb-10 ">
    <setting-tool-bar :breadcrumb="breadcrumb" />
      <div id="kt_app_content" class="app-content  flex-column-fluid ">
          <div id="kt_app_content_container" class="app-container  container-fluid " style="margin-top: 30px!important;">
              <div class="row g-7">
                  <div class="col-lg-3 col-xl-3 col-12 mt-30">
                      <div class="card card-flush">
                          <div class="card-body">
                              <ul class="nav nav-tabs nav-pills nav-fill border-0 flex-column mb-3 mb-md-0 fs-6">
                                  <li v-for="(item, index) in menuItems" :key="index" class="nav-item me-0 mt-4">
                                      <router-link class="nav-link btn btn-light btn-text-gray-600 btn-icon-gray-600 " v-if="$can(item?.permission)"
                                                   :class="[
                           {'active btn-primary': $route.name == item.routeName},
                           {'active btn-primary': item.childRouteName && item.childRouteName.length && item?.childRouteName.includes($route.name)},
                       ]"
                                                   :to="{ name: item.routeName }">
                                          <div class="d-flex align-items-center justify-content-start ">
                                              <i :class="item.icon" class="m-1" ></i>
                                              <span >{{ $t(item.title) }}</span>
                                          </div>
                                      </router-link>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-9 col-xl-9 col-12">
                      <div v-if="$route.name == 'settings-new'" class="card card-flush h-lg-100" id="kt_contacts_main">
                          <div class="card-body p-0">

                              <div class="text-center px-4">
                                <Img filename="empty.png" class="mw-100 mh-300px" alt="" />
                              </div>
                          </div>
                      </div>
                      <router-view v-else></router-view>
                  </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
import SettingToolBar from "@/views/Settings/Layout/SettingToolBar";
import abilities from "@/composables/abilities";
import {mapGetters} from 'vuex'
import Img from "@/components/Img.vue";

export default {
  name: "BaseSettingLayout",
  components: {SettingToolBar, Img},
  data() {
    return {
      breadcrumb:  [
        {routeName:"settings", name:"navigation.setting"},
        {routeName:"settings-company", name:"setting.setting_society", permission: [abilities.VIEW_COMPANY, abilities.VIEW_DEPARTMENT, abilities.VIEW_TAX, abilities.VIEW_POST_OFFICE], routePermission: abilities.VIEW_COMPANY},
        {routeName:"settings-system-mail", name:"setting.setting_system", permission: [
          abilities.EMAIL_MESSAGE_VIEW, abilities.EMAIL_CONFIG_VIEW, abilities.REMIND_CONFIG_VIEW,
          abilities.TEMPLATE_CONFIG_VIEW, abilities.TEMPLATE_CONFIG_VIEW, abilities.VIEW_PAYMENT_TYPE,
          abilities.VIEW_PAYMENT_CONDITION
        ], routePermission: abilities.EMAIL_MESSAGE_VIEW},
        {routeName:"settings-multiSociety", name:"setting.setting_multi_societies"},
        {routeName:"settings-users", name:"setting.setting_user", permission: [abilities.VIEW_RIGHT, abilities.VIEW_USER], routePermission: abilities.VIEW_USER}
      ],
      menuItems: [
        {
          routeName: 'settings-rights',
          title: 'setting.right',
          icon: 'bi bi-shield-check',
          childRouteName: [ 'settings-rights-view'],
          permission: [abilities.VIEW_RIGHT],
        },
        {
          routeName: 'settings-users',
          title: 'setting.users',
          icon: 'fas fa-users',
          childRouteName: [ 'settings-users', 'settings-users-permission-view'],
          permission: [abilities.VIEW_USER],
        },
        {
          routeName: 'settings-users-groups',
          title: 'setting.usersGroups',
          icon: 'fas fa-users',
          childRouteName: [ 'settings-users-groups'],
          permission: [abilities.CAN_VIEW_ACCESS_CONFIG],
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
